import type { Action } from './actions'

export type State = {
    sendFormSuccess: ?boolean,
    sendFormError: ?any,
    networkError?: any
}

const initialState: State = {
    sendFormSuccess: false,
    sendFormError: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'SATISFACTION_SEND_FORM_SUCCESS':
            return {
                ...state,
                sendFormSuccess: true,
                sendFormError: null
            }
        case 'SATISFACTION_SEND_FORM_ERROR':
            return {
                ...state,
                sendFormSuccess: false,
                sendFormError: action.error
            }
        case 'SATISFACTION_RESET_SEND_FORM_SUCCESS':
            return {
                ...state,
                sendFormSuccess: false,
                sendFormError: null
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
